// For generic requests that don't fit elsewhere

import { CALL_API } from '../middleware/api'

import { loadUser } from './user.js';
import { loadSettings } from './settings.js';
import { fetchCart } from './cart.js';
import { setTimedOut, setTimedOutLoggedOut } from './index.js';

export const INIT_REQUEST = 'INIT_REQUEST'
export const INIT_SUCCESS = 'INIT_SUCCESS'
export const INIT_FAILURE = 'INIT_FAILURE'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_AS_REQUEST = 'LOGIN_AS_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'

export const RESET_LOGIN_FAILURE = 'RESET_LOGIN_FAILURE'
export const RESET_LOGOUT_FAILURE = 'RESET_LOGOUT_FAILURE'

export const HEARTBEAT_REQUEST = 'HEARTBEAT_REQUEST'
export const HEARTBEAT_SUCCESS = 'HEARTBEAT_SUCCESS'
export const HEARTBEAT_FAILURE = 'HEARTBEAT_FAILURE'

export const NEW_MEMBER_REQUEST = 'NEW_MEMBER_REQUEST'
export const NEW_MEMBER_SUCCESS = 'NEW_MEMBER_SUCCESS'
export const NEW_MEMBER_FAILURE = 'NEW_MEMBER_FAILURE'

export const PASSWORD_RESET_EMAIL_REQUEST = 'PASSWORD_RESET_EMAIL_REQUEST'
export const PASSWORD_RESET_EMAIL_SUCCESS = 'PASSWORD_RESET_EMAIL_SUCCESS'
export const PASSWORD_RESET_EMAIL_FAILURE = 'PASSWORD_RESET_EMAIL_FAILURE'

export const PASSWORD_RESET_CODE_REQUEST = 'PASSWORD_RESET_CODE_REQUEST'
export const PASSWORD_RESET_CODE_SUCCESS = 'PASSWORD_RESET_CODE_SUCCESS'
export const PASSWORD_RESET_CODE_FAILURE = 'PASSWORD_RESET_CODE_FAILURE'

export const RETRIEVE_MEMBER_EMAIL_REQUEST = 'RETRIEVE_MEMBER_EMAIL_REQUEST'
export const RETRIEVE_MEMBER_EMAIL_SUCCESS = 'RETRIEVE_MEMBER_EMAIL_SUCCESS'
export const RETRIEVE_MEMBER_EMAIL_FAILURE = 'RETRIEVE_MEMBER_EMAIL_FAILURE'

export const RETRIEVE_MEMBER_NO_REQUEST = 'RETRIEVE_MEMBER_NO_REQUEST'
export const RETRIEVE_MEMBER_NO_SUCCESS = 'RETRIEVE_MEMBER_NO_SUCCESS'
export const RETRIEVE_MEMBER_NO_FAILURE = 'RETRIEVE_MEMBER_NO_FAILURE'

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE'

export const LOGO_REQUEST = 'LOGO_REQUEST'
export const LOGO_SUCCESS = 'LOGO_SUCCESS'
export const LOGO_FAILURE = 'LOGO_FAILURE'

export const NAME_BADGE_REQUEST = 'NAME_BADGE_REQUEST'
export const NAME_BADGE_SUCCESS = 'NAME_BADGE_SUCCESS'
export const NAME_BADGE_FAILURE = 'NAME_BADGE_FAILURE'

export const COURSE_WITHDRAWAL_REQUEST = 'COURSE_WITHDRAWAL_REQUEST'
export const COURSE_WITHDRAWAL_SUCCESS = 'COURSE_WITHDRAWAL_SUCCESS'
export const COURSE_WITHDRAWAL_FAILURE = 'COURSE_WITHDRAWAL_FAILURE'

export const UNDO_WITHDRAWAL_REQUEST = 'UNDO_WITHDRAWAL_REQUEST'
export const UNDO_WITHDRAWAL_SUCCESS = 'UNDO_WITHDRAWAL_SUCCESS'
export const UNDO_WITHDRAWAL_FAILURE = 'UNDO_WITHDRAWAL_FAILURE'

const sendRequest = (mappedRequest) => ({
	[CALL_API]: mappedRequest
})

export const makeRequest = (request, data) => (dispatch, getState) => {
	let endpoint, method, types, bad_response;
	
	switch(request){
		case 'login':
			types = [ LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE ];
			endpoint = '/auth/login/';
			method = 'POST';
			bad_response = 'Login failed';
			break;
		case 'login_as':
			types = [ LOGIN_AS_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE ];
			endpoint = '/auth/login/as/';
			method = 'POST';
			bad_response = 'Login failed';
			break;
		case 'logout':
			types = [ LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE ];
			endpoint = '/auth/logout/';
			method = 'POST';
			bad_response = 'Logout failed';
			break;
		case 'new_member':
			types = [ NEW_MEMBER_REQUEST, NEW_MEMBER_SUCCESS, NEW_MEMBER_FAILURE ];
			endpoint = '/new_member/';
			method = 'PUT';
			bad_response = 'Error adding new member to U-MAS database';
			break;
		case 'password_reset_email':
			types = [ PASSWORD_RESET_EMAIL_REQUEST, PASSWORD_RESET_EMAIL_SUCCESS, PASSWORD_RESET_EMAIL_FAILURE ];
			endpoint = '/emails/reset_password/';
			method = 'POST';
			bad_response = 'Failed to send password reset email';
			break;
		case 'password_reset_code':
			types = [ PASSWORD_RESET_CODE_REQUEST, PASSWORD_RESET_CODE_SUCCESS, PASSWORD_RESET_CODE_FAILURE ];
			endpoint = '/auth/update_password/with_code/';
			method = 'POST';
			bad_response = 'Failed to update password';
			break;
		case 'update_password_with_password':
			types = [ UPDATE_PASSWORD_REQUEST, UPDATE_PASSWORD_SUCCESS, UPDATE_PASSWORD_FAILURE];
			endpoint = '/auth/update_password/with_password/';
			method = 'POST';
			bad_response = 'Failed to update password';
			break;
		case 'retrieve_member_email':
			types = [ RETRIEVE_MEMBER_EMAIL_REQUEST, RETRIEVE_MEMBER_EMAIL_SUCCESS, RETRIEVE_MEMBER_EMAIL_FAILURE ];
			endpoint = '/emails/retrieve_member/';
			method = 'POST';
			bad_response = 'Failed to send member retrieval email to admin';
			break;
		case 'retrieve_member_no':
			types = [ RETRIEVE_MEMBER_NO_REQUEST, RETRIEVE_MEMBER_NO_SUCCESS, RETRIEVE_MEMBER_NO_FAILURE ];
			endpoint = '/auth/retrieve_member/';
			method = 'POST';
			bad_response = 'Error retrieving member number from U-MAS database';
			break;
		default:
			return null;
	}
	
	return dispatch(sendRequest({
		types: types,
		endpoint: endpoint,
		method: method,
		params: data,
		bad_response: bad_response
	})).then(result => {
		if(result.type === 'LOGIN_SUCCESS'){
			dispatch(fetchCart());
		} else if(result.type === 'LOGOUT_SUCCESS'){
			if(data === true){
				dispatch(setTimedOutLoggedOut(true))
			}
			dispatch(setTimedOut(false));
		}
	});
}

export const logoRequest = () => (dispatch, getState) => {
	const logo = getState().requests.logo;
	if(logo.image){
		return null;
	}
	return dispatch({
		[CALL_API]: {
			types: [ LOGO_REQUEST, LOGO_SUCCESS, LOGO_FAILURE ],
			endpoint: '/logo/',
			method: 'POST',
			params: null,
			bad_response: 'Error retrieving logo'
		}
	})
}

export const badgeRequest = () => (dispatch, getState) => {
	const badge = getState().requests.name_badge; 
	const user = getState().user;
	const now = Math.floor(Date.now() / 1000);
	
	if(badge.url && badge.expires > now){
		return null;
	}
	
	return dispatch({
		[CALL_API]: {
			types: [ NAME_BADGE_REQUEST, NAME_BADGE_SUCCESS, NAME_BADGE_FAILURE ],
			endpoint: '/name_badges/',
			method: 'POST',
			params: {
				member_no: user.member_no
			},
			bad_response: 'Error retrieving name badge'
		}
	})
}

export const courseWithdrawalRequest = (course_code) => (dispatch, getState) => {
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ COURSE_WITHDRAWAL_REQUEST, COURSE_WITHDRAWAL_SUCCESS, COURSE_WITHDRAWAL_FAILURE ],
			endpoint: '/enrolments/withdraw/',
			method: 'PUT',
			params: {
				member_no: user.member_no,
				course_code: course_code
			},
			bad_response: 'Error submitting course withdrawal request'
		}
	})
	
}

export const undoCourseWithdrawalRequest = (course_code) => (dispatch, getState) => {
	const user = getState().user;
	
	return dispatch({
		[CALL_API]: {
			types: [ UNDO_WITHDRAWAL_REQUEST, UNDO_WITHDRAWAL_SUCCESS, UNDO_WITHDRAWAL_FAILURE ],
			endpoint: '/enrolments/withdraw/',
			method: 'DELETE',
			params: {
				member_no: user.member_no,
				course_code: course_code
			},
			bad_response: 'Error submitting course withdrawal undo request'
		}
	})
	
}

export const initRequest = () => (dispatch, getState) => {
	const currentInit = getState().requests.init;
	if(currentInit === true){
		return null;
	}

	return dispatch({
		[CALL_API]: {
			types: [ INIT_REQUEST, INIT_SUCCESS, INIT_FAILURE ],
			endpoint: '/init/',
			method: 'POST',
			params: null,
			bad_response: 'Security cookie error'
		}
	}).then(result => {
		if(result.type === 'INIT_SUCCESS'){
			dispatch(loadUser());
			dispatch(loadSettings('all'));
			dispatch(logoRequest());
		}
	})
}

export const heartbeatRequest = () => (dispatch, getState) => {
	const lastHeartbeat = getState().requests.heartbeat;
	const now = Math.floor(Date.now() / 1000);

	if(now - lastHeartbeat < 60){
		return null;
	}

	return dispatch({
		[CALL_API]: {
			types: [ HEARTBEAT_REQUEST, HEARTBEAT_SUCCESS, HEARTBEAT_FAILURE ],
			endpoint: '/heartbeat/',
			method: 'POST',
			params: null,
			bad_response: 'Heartbeat cookie error'
		}
	})
}

export const resetLoginFailure = () => ({
    type: RESET_LOGIN_FAILURE
})

export const resetLogoutFailure = () => ({
    type: RESET_LOGOUT_FAILURE
})
